import $api from '@/services/api';

const saveFile = (file, folder) => {
  if (!file) return Promise.reject(new Error('Missing file'));
  if (!folder) return Promise.reject(new Error('Missing folder'));
  return new Promise((resolve, reject) => {
    $api
      .post('/v1/common/cdnitem', {
        folder,
        type: file.type,
      })
      .then((uploadInfo) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', uploadInfo.url);
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(uploadInfo.id);
            } else {
              reject(new Error('Failed to upload file'));
            }
          }
        };
        xhr.send(file);
      });
  });
};

export default saveFile;
